import React from "react";
import {Config} from '../Config';
import {NavLink} from "react-router-dom";

export default function Vision(prop) {
    let [data, setData] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resView = await getView();
                if(prop !== null && prop.lang === 'en') {
                    resView.vision = resView.vision_en;
                    resView.vision1 = resView.vision1_en;
                    resView.vision2 = resView.vision2_en;
                    resView.mission = resView.mission_en;
                    resView.mission1_text1 = resView.mission1_text1_en;
                    resView.mission1_text2 = resView.mission1_text2_en;
                    resView.mission2_text1 = resView.mission2_text1_en;
                    resView.mission2_text2 = resView.mission2_text2_en;
                    resView.mission3_text1 = resView.mission3_text1_en;
                    resView.mission3_text2 = resView.mission3_text2_en;
                    resView.mission4_text1 = resView.mission4_text1_en;
                    resView.mission4_text2 = resView.mission4_text2_en;
                    resView.banner2_text1 = resView.banner2_text1_en;
                    resView.banner2_text2 = resView.banner2_text2_en;
                    resView.detail1 = resView.detail1_en;
                    resView.detail2 = resView.detail2_en;
                }

                if(resView) {
                    setData(resView);

                    let title = (prop.lang === 'en' ? 'Vision and Mission':'วิสัยทัศน์ และพันธกิจ') + ' | NCSA';
                    document.title = title;
                    const elDesc = document.querySelector("meta[name='description']");
                    elDesc.setAttribute('content', title);
                    const elOgTitle = document.querySelector("meta[property='og:title']");
                    elOgTitle.setAttribute('content', title);
                    const elOgDesc = document.querySelector("meta[property='og:description']");
                    elOgDesc.setAttribute('content', title);
                    const elOgImage = document.querySelector("meta[property='og:image']");
                    elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
                    const elOgUrl = document.querySelector("meta[property='og:url']");
                    elOgUrl.setAttribute('content', window.location.href);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/vision/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.banner1 ? <img src={Config.fileUpload + 'vision/' + data?.banner1} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Home':'เกี่ยวกับ สกมช.'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'About the agency':'เกี่ยวกับหน่วยงาน'} / {prop.lang === 'en' ? 'Vision':'วิสัยทัศน์และพันธกิจ'}</p>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <div className="article-item d-block m-0">
                        <h2 className="title-line-left fs-28 textrow">
                            <span data-aos="fade-right">{data?.vision}</span>
                        </h2>

                        {
                            data?.vision1 ? <h3 className="fs-28 mb-2">“{data?.vision1}”</h3> : ''
                        }

                        {
                            data?.vision2 ? <p><div dangerouslySetInnerHTML={{__html: data?.vision2.replace(/\n/g, "<br />")}}></div></p> : ''
                        }
                    </div>

                    <div className="py-3 py-md-4 my-xl-2">
                        <hr />
                    </div>

                    <h2 className="title-line-left fs-28 mt-0 textrow">
                        <span data-aos="fade-right">{data?.mission}</span>
                    </h2>

                    <div className="row g-sm-4 g-3 pt-md-4 pt-2">
                        {
                            data?.mission1_text1 ?
                                <>
                                    <div className="col-md-6">
                                        <div className="card-mission" data-aos="fade-in">
                                            {
                                                data?.mission1_image ? <div className="card-icon">
                                                    <img className="icons" src={Config.fileUpload + 'vision/' + data?.mission1_image} alt="" />
                                                </div> : ''
                                            }
                                            <div className="card-body">
                                                <h3>{data?.mission1_text1}</h3>
                                                <p>{data?.mission1_text2}</p>
                                            </div>
                                        </div>
                                    </div>

                                </> : ''
                        }
                        {
                            data?.mission2_text1 ?
                                <>
                                    <div className="col-md-6">
                                        <div className="card-mission" data-aos="fade-in">
                                            {
                                                data?.mission2_image ? <div className="card-icon">
                                                    <img className="icons" src={Config.fileUpload + 'vision/' + data?.mission2_image} alt="" />
                                                </div> : ''
                                            }
                                            <div className="card-body">
                                                <h3>{data?.mission2_text1}</h3>
                                                <p>{data?.mission2_text2}</p>
                                            </div>
                                        </div>
                                    </div>

                                </> : ''
                        }

                        {
                            data?.mission3_text1 ?
                                <>
                                    <div className="col-md-6">
                                        <div className="card-mission" data-aos="fade-in">
                                            {
                                                data?.mission3_image ? <div className="card-icon">
                                                    <img className="icons" src={Config.fileUpload + 'vision/' + data?.mission3_image} alt="" />
                                                </div> : ''
                                            }
                                            <div className="card-body">
                                                <h3>{data?.mission3_text1}</h3>
                                                <p>{data?.mission3_text2}</p>
                                            </div>
                                        </div>
                                    </div>

                                </> : ''
                        }

                        {
                            data?.mission4_text1 ?
                                <>
                                    <div className="col-md-6">
                                        <div className="card-mission" data-aos="fade-in">
                                            {
                                                data?.mission4_image ? <div className="card-icon">
                                                    <img className="icons" src={Config.fileUpload + 'vision/' + data?.mission4_image} alt="" />
                                                </div> : ''
                                            }
                                            <div className="card-body">
                                                <h3>{data?.mission4_text1}</h3>
                                                <p>{data?.mission4_text2}</p>
                                            </div>
                                        </div>
                                    </div>

                                </> : ''
                        }
                    </div>
                </div>

                {
                    data?.banner2_text1 ?
                        <>
                            <div className="mission-banner" data-aos="fade-in">
                                {
                                    data?.banner2 ? <div className="background" style={{backgroundImage: 'url("' + Config.fileUpload + 'vision/' + data?.banner2 + '")'}} /> : ''
                                }

                                <div className="group">
                                    <h2 className="textrow"><span data-aos="fade-up">{data?.banner2_text1}</span></h2>
                                    <h3 className="textrow"><span data-aos="fade-up"
                                                                  data-aos-delay="200">{data?.banner2_text2}</span></h3>
                                </div>
                            </div>
                        </> : ''
                }

                {
                    data?.detail2 ?
                        <>
                            <div className="container">
                                {
                                    data?.detail1 ? <h2 className="title-line-left fs-28 textrow">
                                        <span data-aos="fade-right">{data?.detail1}</span>
                                    </h2> : ''
                                }

                                <div className="article pt-2 pt-sm-3" style={{'--color':'#5D5D5D'}} data-aos="fade-in">
                                    <div dangerouslySetInnerHTML={{__html: data?.detail2.replace(/\n/g, "<br />")}}></div>
                                </div>
                            </div>
                        </> : ''
                }

            </div>
        </>
    );
} 